// Standalone lazy-image loader (swaps data-src -> src via IntersectionObserver).
//
// The made-for-mobile homepage deliberately skips the main `application`
// webpacker pack (~2.3MB of React) — see the gate in
// app/views/layouts/application.html.erb. But it still renders the shared promo
// partials (three_d, illustrator_plugin, dielines_api) whose images use the
// data-src lazy pattern, and lazyLoading.js used to ship only inside that pack.
// Without it the images never load (the placeholder SVG is never replaced).
//
// This tiny pack carries just the loader so the responsive-viewport page keeps
// lazy loading without pulling the whole React bundle back in.
import '../utils/lazyLoading'
